<script setup lang="ts">
    import { defineProps, toRefs, withDefaults } from "vue";
    import KAutocomplete from "@/components/forms/inputs/Autocomplete/KAutocomplete.vue";
    import { fetchStudieKvalitetsregister } from "@/components/forms/reusables/studieKvalitetsregisterHelper";

    const props = withDefaults(
        defineProps<{
            name?: string;
            label?: string;
            multiple?: boolean;
            ignoreEmptyData?: boolean;
        }>(),
        {
            name: "studie_kvalitetsregister",
            label: "Studie/Kvalitetsregister",
            multiple: false,
            ignoreEmptyData: true,
        }
    );

    const { name, label, multiple, ignoreEmptyData } = toRefs(props);
</script>

<template>
    <KAutocomplete
        v-bind="$attrs"
        :name="name"
        :multiple="multiple"
        :options="fetchStudieKvalitetsregister"
        :label="label"
        :ignoreEmptyData="ignoreEmptyData"
    />
</template>
